import React from 'react'

export const useWindowResize = ({cssAtts, breakpoint}: any) => {

  const [underBreakpoint, setUnderBreakpoint] = React.useState<boolean>(false);
  const mobileBreakpoint = React.useMemo(() => breakpoint, [breakpoint]);

  // const [sizes, setSizes] = React.useState({
  //   windowWidth: window.innerWidth,
  //   windowHeight: window.innerHeight,
  // })

  // TODO: Watch element resize
  React.useLayoutEffect(() => {
    const updateWindowSize = () => {
      if (cssAtts) {
        document.documentElement.style.setProperty(
          '--vh',
          `${window.innerHeight * 0.01}px`, 
        )
        document.documentElement.style.setProperty(
          '--vw',
          `${window.innerWidth * 0.01}px`,
        )
      }
      
      setUnderBreakpoint( window.innerWidth <= mobileBreakpoint );
      
      // setSizes({
      //   windowWidth: window.innerWidth,
      //   windowHeight: window.innerHeight,
      // })
    }

    window.addEventListener('resize', updateWindowSize)
    updateWindowSize()

    return () => window.removeEventListener('resize', updateWindowSize)
  }, [])

  //return sizes
  return [underBreakpoint]
}
